module.exports = __webpack_public_path__ + "img/product_segment.5fb63c70.svg";